// Interface templates: whole-UI shells the console can start in.
// "Templates" elsewhere in the console means odds ladder templates; this is
// unrelated, hence the uiTemplate naming.
//
// The choice is per browser (localStorage) and is read once per page load by
// main.js (root component) and the router (route overrides), so switching
// saves the choice and reloads the page. Both templates share the same URLs.

export const UI_TEMPLATES = [
  {
    id: 'classic',
    name: 'Classic',
    description: 'The current console: sidebar with sub-menus.',
    preview: 'sidebar'
  },
  {
    id: 'next',
    name: 'New (preview)',
    description: 'New lean layout, under development. Pages not rebuilt yet open in their classic version.',
    preview: 'topbar'
  }
]

const STORAGE_KEY = 'oc.uiTemplate.v1'
const DEFAULT_ID = 'classic'

const isKnown = (id) => UI_TEMPLATES.some(t => t.id === id)

function resolveActiveId() {
  try {
    // ?ui=classic|next sets and saves the choice: the way back if a template breaks.
    const params = new URLSearchParams(window.location.search)
    const fromUrl = params.get('ui')
    if (isKnown(fromUrl)) {
      localStorage.setItem(STORAGE_KEY, fromUrl)
      params.delete('ui')
      const query = params.toString()
      window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + (query ? `?${query}` : '') + window.location.hash
      )
      return fromUrl
    }
    const saved = localStorage.getItem(STORAGE_KEY)
    return isKnown(saved) ? saved : DEFAULT_ID
  } catch {
    return DEFAULT_ID
  }
}

export const activeUiTemplateId = resolveActiveId()

export function setUiTemplate(id) {
  if (!isKnown(id) || id === activeUiTemplateId) return
  localStorage.setItem(STORAGE_KEY, id)
  window.location.reload()
}
